import { render, staticRenderFns } from "./MsSiderBar.vue?vue&type=template&id=5b6517eb&scoped=true"
import script from "./MsSiderBar.vue?vue&type=script&lang=js"
export * from "./MsSiderBar.vue?vue&type=script&lang=js"
import style0 from "./MsSiderBar.vue?vue&type=style&index=0&id=5b6517eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6517eb",
  null
  
)

export default component.exports